import React, { Component } from 'react';
//import Chart from 'react-google-charts';
import ShowIff from '../../ui/ShowIff.js';
import Box from '../../ui/Box.js';

import './summary.scss';

class Summary extends Component {
	render() {
		return (
			<Box className={"Field Summary" + (this.props.discontinued ? " discontinued" : "")} title={this.props.FieldNumber} to={"/farm/" + this.props.FarmID + '/field/' + this.props.FieldID}>
				<div className="summary">
					<ShowIff iff={this.props.discontinued}>
						<p className="discontinued">Discontinued on {this.props.DiscontinuedDate}</p>
					</ShowIff>
					<p>{this.props.Acres} acres of {this.props.CropName} – {this.props.VarietyName}</p>
					<p>[Graph of production per acre, over the past few years]</p>
				</div>
			</Box>
		);
	}
}

export default Summary;
